import { Card } from "reactstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Icon from "../Icon/Icon";
import TableCalendarFilter from "../TableCalendarFilter/TableCalendarFilter";
import FilterSelect from "../FilterSelect/FilterSelect";
import {
  ticketTypeItems,
  sortItems,
  convertTicketTypeToText,
  convertSortToText,
  transactionTypeItems,
  convertTransactionTypeToText,
  convertReceptionOrderStatusToText,
  receptionOrderStatusItems,
} from "../../utils/enum";
import { addAllItemToFilters } from "../../utils";
import { Row } from "../Grid/Grid";

const itemsCountItems = [
  10, 25, 50, 75, 100, 150, 200, 300, 400, 500, 600, 700,
];

const TableFilter = ({
  setStart,
  start,
  setEnd,
  end,
  setItemsCount,
  itemsCount,
  setSort,
  sort,
  setIsActive,
  isActive,
  setIsConfirm,
  isConfirm,
  setTicketStatus,
  ticketStatus,
  setTransactionStatus,
  transactionStatus,
  receptionOrderStatus,
  setReceptionOrderStatus,
}) => {
  const { pathname } = useLocation();

  const meta = useSelector((state) => state.meta);

  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setIsShow(false);
  }, [pathname]);

  return (
    <Card className="mb-3">
      <div className="card-inner position-relative card-tools-toggle">
        <div
          className="d-flex justify-content-between align-items-center"
          type="button"
          onClick={() => setIsShow(!isShow)}
        >
          <div>جستجو پیشرفته</div>
          <div>
            <Icon name={`${isShow ? "upword" : "downward"}-ios`} />
          </div>
        </div>
        {isShow && (
          <>
            <hr />
            <div className="card-tools mr-n1">
              <Row className="align-items-end">
                {setItemsCount && (
                  <FilterSelect
                    title="تعداد"
                    items={itemsCountItems.map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    value={itemsCount}
                    onChange={setItemsCount}
                  />
                )}
                {setSort && (
                  <FilterSelect
                    title="چیدمان"
                    items={addAllItemToFilters(
                      sortItems.map((item) => ({
                        label: convertSortToText(item),
                        value: item,
                      })),
                      "پیشفرض"
                    )}
                    value={sort}
                    onChange={setSort}
                  />
                )}
                {setIsActive && (
                  <FilterSelect
                    title="وضعیت"
                    items={addAllItemToFilters([
                      {
                        label: "فعال",
                        value: "true",
                      },
                      {
                        label: "غیرفعال",
                        value: "false",
                      },
                    ])}
                    value={isActive}
                    onChange={setIsActive}
                  />
                )}
                {setIsConfirm && (
                  <FilterSelect
                    title="وضعیت اطلاعات"
                    items={addAllItemToFilters([
                      {
                        label: "تایید شده",
                        value: "true",
                      },
                      {
                        label: "در انتظار تایید",
                        value: "false",
                      },
                    ])}
                    value={isConfirm}
                    onChange={setIsConfirm}
                  />
                )}
                {setTicketStatus && (
                  <FilterSelect
                    title="وضعیت تیکت"
                    items={addAllItemToFilters(
                      ticketTypeItems?.map((item) => ({
                        label: convertTicketTypeToText(item),
                        value: item,
                      }))
                    )}
                    value={ticketStatus}
                    onChange={setTicketStatus}
                  />
                )}
                {setTransactionStatus && (
                  <FilterSelect
                    title="وضعیت تراکنش"
                    items={addAllItemToFilters(
                      transactionTypeItems?.map((item) => ({
                        label: convertTransactionTypeToText(item),
                        value: item,
                      }))
                    )}
                    value={transactionStatus}
                    onChange={setTransactionStatus}
                  />
                )}
                {setReceptionOrderStatus && (
                  <FilterSelect
                    title="وضعیت سفارش پذیرندگان"
                    items={addAllItemToFilters(
                      receptionOrderStatusItems?.map((item) => ({
                        label: convertReceptionOrderStatusToText(item),
                        value: item,
                      }))
                    )}
                    value={receptionOrderStatus}
                    onChange={setReceptionOrderStatus}
                  />
                )}
              </Row>
              {setStart && setEnd && (
                <Row className="align-items-end">
                  <TableCalendarFilter
                    setStart={setStart}
                    start={start}
                    setEnd={setEnd}
                    end={end}
                  />
                </Row>
              )}
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

export default TableFilter;
